export default __webpack_public_path__ + "static/media/logo-color.5d730250.svg";